<div class="container">

    <section class='header'>
        <mat-toolbar color='primary' fxLayoutAlign="space-between">
            <div class='header-title'>
                <mat-icon style='font-size:.9em;'>attach_money</mat-icon>
                <div class='title'>
                    Preços 
                </div>
            </div>

            <button class="button-close" mat-raised-button mat-dialog-close>
                <mat-icon>close</mat-icon>
            </button>

        </mat-toolbar>
    </section>

    <div class='price-form'>

        <form name="priceForm" [formGroup]='priceForm' autocomplete="off">
            
            <mat-form-field class="category-width" appearance="fill">
                <mat-label>Categoria</mat-label>

                <mat-select (ngModelChange)='selectCategory($event)' [errorStateMatcher]="matcher"
                    [formControl]="priceForm.controls.category_id">
                    <mat-option *ngFor="let category of _productPriceService.arrayCategories" [value]="category.id">
                        {{ category.name }}
                    </mat-option>
                </mat-select>

                <mat-error *ngIf="priceForm.controls.category_id.hasError('required')">
                    Selecione uma categoria
                </mat-error>
            </mat-form-field>

            <mat-form-field class="value-width" appearance="fill">
              <label>Adimplente</label>
                <input matInput type="number" [errorStateMatcher]="matcher" [formControl]="priceForm.controls.value"
                    autocomplete="off">
                <mat-error *ngIf="priceForm.controls.value.hasError('required')">
                    O Valor é obrigatório
                </mat-error>
            </mat-form-field>

            <mat-form-field class="value-width" appearance="fill">
              <label>inadimplente</label>
                <input matInput type="number" [errorStateMatcher]="matcher" [formControl]="priceForm.controls.value"
                   autocomplete="off">
                <mat-error *ngIf="priceForm.controls.value.hasError('required')">
                    O Valor é obrigatório
                </mat-error>
            </mat-form-field>


            <button mat-raised-button (click)='addPrice()' [disabled]="priceForm.invalid">
                <mat-icon class='icon-done'>check_circle_outline</mat-icon>
            </button>

        </form>

    </div>

</div>